import { Navigate } from "react-router-dom";

export const GuestRoute = ({ children }: { children: React.ReactNode }) => {
  const token = localStorage.getItem("accessToken");
  return token ? <Navigate to="/home" replace /> : <>{children}</>;
};
